export default __webpack_public_path__ + "static/drum-roll-765c0b2037859ce6e3014fc79308fa46.mp3";